import React from 'react';

/**
 * ModeBadge — tiny pill that tells the user whether a tool is DIY or Guided.
 *   - DIY    → green   (self-paced, do-it-yourself)
 *   - Guided → purple  (advisor-led / requires guidance)
 *
 * Used in the dashboard left sidebar (menu items + value-added services).
 */
const MODE_STYLES = {
  diy: {
    label: 'DIY',
    cls: 'bg-green-500/20 text-green-300 border-green-500/40',
    title: 'Do-It-Yourself — self-paced',
  },
  guided: {
    label: 'Guided',
    cls: 'bg-purple-500/20 text-purple-300 border-purple-500/40',
    title: 'Guided — advisor will assist you',
  },
};

const ModeBadge = ({ mode, size = 'sm' }) => {
  const style = MODE_STYLES[mode];
  if (!style) return null;

  const sizing = size === 'xs'
    ? 'px-1.5 py-px text-[8px]'
    : 'px-1.5 py-0.5 text-[9px]';

  return (
    <span
      title={style.title}
      data-testid={`mode-badge-${mode}`}
      className={`inline-flex items-center font-bold uppercase tracking-wide rounded border ${sizing} ${style.cls}`}
    >
      {style.label}
    </span>
  );
};

export default ModeBadge;
